import { concat, flatten } from 'lodash/fp';

// @ts-expect-error - Automatic, Please fix when editing this file
const getSubtextValue = (subtext, ends) => {
  const endsValue = ends?.value;

  if (!endsValue) return subtext;
  const spacer = { type: 'span', value: ' ' };

  return {
    ...subtext,
    value: concat(subtext.value, endsValue && flatten([spacer, endsValue])),
  };
};

export default getSubtextValue;
